import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { isComposingKeyEvent } from 'src/app/utils/keyboard-event.util';

declare global {
  interface Window {
    API?: unknown;
    API_1484_11?: unknown;
    Scorm12API?: new (settings?: Record<string, unknown>) => unknown;
    Scorm2004API?: new (settings?: Record<string, unknown>) => unknown;
  }
}

const SCORM_AGAIN_CDN_URL = 'https://cdn.jsdelivr.net/npm/scorm-again@3.1.5/dist/scorm-again.min.js';

@Component({
  selector: 'app-scorm',
  templateUrl: './scorm.component.html',
  styleUrls: ['./scorm.component.scss'],
  standalone: false,
})
export class ScormComponent {
  @ViewChild('urlInput') urlInput!: ElementRef<HTMLInputElement>;

  safeUrl: SafeResourceUrl;

  constructor(private readonly sanitizer: DomSanitizer) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
  }

  ngOnInit(): void {
    this.loadScormAgain();
  }

  handleUrlInputKeydown(event: Event): void {
    if (isComposingKeyEvent(event as KeyboardEvent)) return;
    this.onLoad();
  }

  onLoad(): void {
    const url = this.urlInput.nativeElement.value.trim();
    if (!url) {
      return;
    }
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private loadScormAgain(): void {
    if (window.Scorm12API) {
      this.initApis();
      return;
    }
    const script = document.createElement('script');
    script.src = SCORM_AGAIN_CDN_URL;
    script.onload = () => this.initApis();
    document.head.appendChild(script);
  }

  private initApis(): void {
    // Instantiate both versions since we don't know upfront whether a given
    // course is SCORM 1.2 or 2004 — the course itself searches window.parent
    // for whichever API name it expects.
    window.API = new window.Scorm12API!({ autocommit: true });
    window.API_1484_11 = new window.Scorm2004API!({ autocommit: true });
  }
}
